import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import TaskForm from "@/features/task/components/taskForm/TaskForm";
import useTaskDetails from "@/features/task/hooks/useTaskDetails";
const TaskEdit = () => {
    const { taskId } = useParams();
    const navigate = useNavigate();
    const { handleUpdateTask, loading, error } = useTaskDetails(Number(taskId));
    const handleSubmit = async (data) => {
        try {
            await handleUpdateTask(data);
            navigate(`/tasks/${taskId}`);
        }
        catch (err) {
            console.error("Erreur lors de la sauvegarde de la tâche :", err);
            toast.error(`Erreur : ${err.message}`);
        }
    };
    const handleCancel = () => navigate(-1);
    if (loading) {
        return _jsx("div", { className: "p-4", children: "Chargement..." });
    }
    if (error) {
        return _jsxs("div", { className: "p-4 text-red-500", children: ["Erreur : ", error] });
    }
    return (_jsx("div", { className: "bg-white min-h-screen", children: _jsx(TaskForm, { taskId: Number(taskId), onSubmit: handleSubmit, onCancel: handleCancel }) }));
};
export default TaskEdit;
